export default __webpack_public_path__ + "static/media/3.c2dd6129.jpg";